import z from 'zod';
import { ChartPointSchema } from './chartPoint.entity';

export const CISOIndustryNewSchema = z.object({
  title: z.string(),
  description: z.string(),
  url: z.string().nullable(),
});
export const CISOIndustryNewsSchema = z.array(CISOIndustryNewSchema);

export const CISOSIEMIngestionTrendSchema = z.object({
  name: z.string(),
  data: z.array(ChartPointSchema),
});
export const CISOSIEMIngestionTrendsSchema = z.array(CISOSIEMIngestionTrendSchema);

export type CISOIndustryNew = z.infer<typeof CISOIndustryNewSchema>;
export type CISOIndustryNews = z.infer<typeof CISOIndustryNewsSchema>;
export type CISO_SIEMIngestionTrend = z.infer<typeof CISOSIEMIngestionTrendSchema>;
export type CISO_SIEMIngestionTrends = z.infer<typeof CISOSIEMIngestionTrendsSchema>;

// Entity for compliance

const ComplianceValueSchema = z.array(z.string());

const ComplianceItemSchema = z.object({
  headers: z.array(z.string()),
  values: z.array(ComplianceValueSchema),
  name: z.string(),
});

const ComplianceSectionSchema = z.record(z.array(ComplianceItemSchema));

export const ComplianceDataSchema = z.array(ComplianceSectionSchema);

// Define TypeScript types based on the Zod schema
export type ComplianceValue = z.infer<typeof ComplianceValueSchema>;
export type ComplianceItem = z.infer<typeof ComplianceItemSchema>;
export type ComplianceSection = z.infer<typeof ComplianceSectionSchema>;
export type ComplianceData = z.infer<typeof ComplianceDataSchema>;

export enum SoldProductType {
  EDR = 'EDR',
  SIEM = 'SIEM',
  VULNERABILITY_MANAGEMENT = 'Vulnerability Management',
  EMAIL_SECURITY = 'Email Security',
}
